import React from 'react'
import Terms from '../../Componet/Terms'
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader'
import ServerCare1 from '../../Componet/ServerCare/SERVERCARE1'


function TermsConditions() {
    return (
        <>
            <HerosectionHeader folder1={"pages"} folder2={"Utilities"} name={"Server Care"} />
            <div class="page-content">
                <ServerCare1></ServerCare1>
                <NewsletterL1 />
            </div>
        </>
    )
}

export default TermsConditions
